import React from "react";

interface ScrollyStepProps {
  stepNumber: string;
  label: string;
  headline: string;
  body: string;
  children: React.ReactNode;
  align?: "left" | "right";
  bg?: "white" | "gray" | "black";
}

export default function ScrollyStep({
  stepNumber,
  label,
  headline,
  body,
  children,
  align = "left",
  bg = "white",
}: ScrollyStepProps) {
  const bgClass =
    bg === "black" ? "bg-black text-white" : bg === "gray" ? "bg-gray-50" : "bg-white";

  const copyCol = (
    <div className="scrolly-reveal stack gap-5 py-8 lg:py-0">
      <div className="stack gap-1.5">
        <div className="flex items-baseline gap-3 text-base uppercase">
          <span
            style={{ color: "#F50078" }}
          >
            Step {stepNumber}
          </span>

          <span
            className={`text-[1rem] uppercase tracking-[0.25em] font-bold ${
              bg === "black" ? "text-white/50" : "text-black"
            }`}
          >
            / {label}
          </span>
        </div>
      </div>
      <h2
        className={`type-4 font-black uppercase leading-[0.92] text-balance type-display ${
          bg === "black" ? "text-white" : "text-black"
        }`}
      >
        {headline}
      </h2>
      <p className={`text-sm leading-relaxed max-w-sm ${bg === "black" ? "text-white/60" : "text-gray-500"}`}>
        {body}
      </p>
    </div>
  );

  const visualCol = (
    <div className="scrolly-reveal-slow flex items-center justify-center py-8 lg:py-0 min-h-[320px]">
      {children}
    </div>
  );

  return (
    <div className={`${bgClass} border-b border-black/10`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
        <div className="grid gap-8 lg:gap-16 lg:grid-cols-2 items-center">
          {align === "left" ? (
            <>
              {copyCol}
              {visualCol}
            </>
          ) : (
            <>
              {visualCol}
              {copyCol}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
